module.exports = __webpack_public_path__ + "img/3-2.6c2f4104.png";